module.exports = __webpack_public_path__ + "img/icon-clock.0bb0dce6.svg";